module.exports = __webpack_public_path__ + "img/home-title3.72879da8.png";